<template>
  <div class="content-box">
    <div class="scan-box">
      <div class="angle-box">
        <div
          class="angle-box-item"
          style="top: calc(0px - var(--angle-weight)); left: calc(0px - var(--angle-weight))"
        ></div>
        <div
          class="angle-box-item"
          style="top: calc(0px - var(--angle-weight)); right: calc(0px - var(--angle-weight))"
        ></div>
        <div
          class="angle-box-item"
          style="bottom: calc(0px - var(--angle-weight)); left: calc(0px - var(--angle-weight))"
        ></div>
        <div
          class="angle-box-item"
          style="bottom: calc(0px - var(--angle-weight)); right: calc(0px - var(--angle-weight))"
        ></div>
      </div>
      <div class="image-box">
        <img class="scan-image" :src="imgSrc" />
      </div>
      <div class="scan-wake-box">
        <div class="scan-wake-inner"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps(["imgSrc"]);
const imgSrc = props.imgSrc;
</script>

<style scoped lang="less">
.content-box {
  width: 100%;
  height: 100%;
  background-color: black;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style>
:root {
  --container-width: 98%; /*组件宽度*/
  --container-height: 400px; /*组件高度*/
  --angle-size: 20px; /*四角边框效果尺寸*/
  --angle-weight: 4px; /*四角边框粗细，数值越小越粗*/
  --angle-color: #2bca9c;
  --scan-wake-size: 80px; /*扫描拖光的长度*/
  --scan-wake-color: rgba(43, 202, 156, 0.5); /*扫描拖光颜色*/
}

@keyframes scan {
  0% {
    /*最开始块从顶部往下移动，块的位置需要溢出容器，处于容器顶部上方，块的背景颜色从底部到顶部由绿色逐渐透明*/
    margin-top: calc(0px - var(--scan-wake-size));
    background: linear-gradient(#0000 0%, var(--scan-wake-color) 100%);
  }
  49% {
    /*动画进行到一半时间时，块必须移动到容器底部并溢出，完成从上到下扫描效果*/
    margin-top: var(--container-height);
    background: linear-gradient(#0000 0%, var(--scan-wake-color) 100%);
  }
  50% {
    /*调转颜色方向，准备往回扫（从下往上）*/
    margin-top: var(--container-height);
    background: linear-gradient(var(--scan-wake-color) 0%, #0000 100%);
  }
  100% {
    /*往回扫*/
    margin-top: calc(0px - var(--scan-wake-size));
    background: linear-gradient(var(--scan-wake-color) 0%, #0000 100%);
  }
}

.angle-box {
  position: absolute;
  z-index: 0;
  width: inherit;
  height: inherit;
}

.angle-box-item {
  position: absolute;
  width: var(--angle-size);
  height: var(--angle-size);
  background-color: var(--angle-color);
}

.scan-box {
  width: var(--container-width);
  height: var(--container-height);
  border: 1px solid green;
}

.image-box {
  position: absolute;
  z-index: 10;
  width: inherit;
  height: inherit;
  background-color: white;
}

.scan-image {
  width: inherit;
  height: inherit;
  object-fit: contain;
  text-align: center;
}

.scan-wake-box {
  position: absolute;
  z-index: 20;
  width: inherit;
  height: inherit;
  overflow: hidden;
}

.scan-wake-inner {
  width: 100%;
  height: var(--scan-wake-size);
  animation: scan 4s ease-in-out infinite;
}
</style>